__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "container-forms";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@mantine/core", "6.0.1", () => (Promise.all([__webpack_require__.e(243), __webpack_require__.e(900), __webpack_require__.e(830), __webpack_require__.e(357)]).then(() => (() => (__webpack_require__(243))))));
			register("@mantine/hooks", "6.0.1", () => (Promise.all([__webpack_require__.e(328), __webpack_require__.e(900)]).then(() => (() => (__webpack_require__(328))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(749), __webpack_require__.e(900)]).then(() => (() => (__webpack_require__(749))))));
			register("react", "18.2.0", () => (__webpack_require__.e(969).then(() => (() => (__webpack_require__(969))))));
			register("web-vitals", "2.1.4", () => (__webpack_require__.e(415).then(() => (() => (__webpack_require__(415))))));
			initExternal(772);
			initExternal(679);
			initExternal(966);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};